export interface RingtoneOption {
  key: string;
  labelKey: string; // key di t.profile — e.g. t.profile.ringtoneClassic
  file: string | null; // null = programmatic beep fallback
}

export const RINGTONES: RingtoneOption[] = [
  { key: 'classic', labelKey: 'ringtoneClassic', file: '/ringtones/classic.mp3' },
  { key: 'iphone',  labelKey: 'ringtoneIphone',  file: '/ringtones/i_phone.mp3' },
  { key: 'gentle',  labelKey: 'ringtoneGentle',  file: '/ringtones/love_language.mp3' },
  { key: 'digital', labelKey: 'ringtoneDigital', file: '/ringtones/xylophone.mp3' },
  { key: 'beep',    labelKey: 'ringtoneBeep',    file: null },
];

const LS_KEY = 'app_ringtone';
const DEFAULT = 'classic';

export const getRingtoneKey  = (): string          => localStorage.getItem(LS_KEY) || DEFAULT;
export const setRingtoneKey  = (key: string): void => localStorage.setItem(LS_KEY, key);
export const getRingtoneFile = (): string | null    => RINGTONES.find(r => r.key === getRingtoneKey())?.file ?? null;
